// INSPIYAH Weekly Cadence — single source of truth (Build Bible §XI).
// Each weekday can carry MORE THAN ONE branded name ("variant") depending on
// the messaging — same day, same theme/color, different wording.
// Mirrors the gradients used on the homepage (Yahffirmations.jsx).

export const DAY_THEMES = {
  'magnificent-new-dawn-mondays': {
    variants: ['Magnificent New Dawn Mondays', 'Manifest Mondays'],
    acronym: 'MND', theme: 'Gratitude', weekday: 'Monday',
    gradient: 'from-gray-900 via-black to-gray-800', text: 'text-yellow-300',
    hashtags: ['#magnificentnewdawn'],
  },
  'teach-me-tuesdays': {
    variants: ['Teach Me Tuesdays'],
    acronym: 'TMT', theme: 'Divine Names', weekday: 'Tuesday',
    gradient: 'from-purple-900 via-indigo-800 to-blue-900', text: 'text-purple-200',
    hashtags: ['#teachmetuesday'],
  },
  'wisdom-wednesdays': {
    variants: ['Wisdom Wednesdays'],
    acronym: 'WW', theme: 'Living Truth', weekday: 'Wednesday',
    gradient: 'from-emerald-900 via-green-800 to-teal-900', text: 'text-emerald-200',
    hashtags: ['#wisdomwednesday'],
  },
  'thankful-thursdays': {
    variants: ['Thankful Thursdays', 'Thriving Thursdays'],
    acronym: 'TT', theme: 'Divine Protection', weekday: 'Thursday',
    gradient: 'from-blue-900 via-cyan-800 to-blue-800', text: 'text-cyan-200',
    hashtags: ['#thankfulthursdays', '#thrivingthursdays'],
  },
  'happy-fridays': {
    variants: ['Happy Fridays', 'Fly Frequency Fridays', 'FLY Fridays'],
    acronym: 'HF', theme: 'Faith & Fiyah', weekday: 'Friday',
    gradient: 'from-yellow-700 via-amber-600 to-orange-600', text: 'text-yellow-100',
    hashtags: ['#happyfridays', '#flyfridays'],
  },
  'sacred-saturdays': {
    variants: ['Sacred Saturdays', 'Soulful Saturdays'],
    acronym: 'SS', theme: 'Family & Love', weekday: 'Saturday',
    gradient: 'from-orange-700 via-red-600 to-orange-800', text: 'text-orange-100',
    hashtags: ['#sacredsaturdays'],
  },
  'siren-sundayz': {
    variants: ['Siren Sundayz', 'Sacred Sundays'],
    acronym: 'SS', theme: 'INSPIYAH Culture + Pillar Pulse', weekday: 'Sunday',
    gradient: 'from-red-900 via-rose-800 to-red-800', text: 'text-rose-200',
    hashtags: ['#sirensundayz'],
  },
};

// Flat list of every selectable variant (for the importer dropdown), in Mon→Sun order.
export const DAY_THEME_OPTIONS = Object.entries(DAY_THEMES).flatMap(([key, d]) =>
  d.variants.map((v) => ({ value: v, label: `${v} — ${d.theme}`, key }))
);

// Resolve a stored day-theme string (any variant / weekday) to its canon entry.
// `displayName` echoes the exact variant chosen so the ribbon shows what was selected.
export const resolveDayTheme = (value) => {
  if (!value) return null;
  const norm = value.trim().toLowerCase();
  for (const [key, d] of Object.entries(DAY_THEMES)) {
    const match = d.variants.find((v) => v.toLowerCase() === norm);
    if (match) return { key, ...d, displayName: match };
  }
  // fallbacks: slugified key match, or weekday name contained in the string
  const byKey = Object.keys(DAY_THEMES).find((k) => k === norm.replace(/\s+/g, '-'));
  if (byKey) return { key: byKey, ...DAY_THEMES[byKey], displayName: DAY_THEMES[byKey].variants[0] };
  const byWeekday = Object.keys(DAY_THEMES).find((k) => norm.includes(DAY_THEMES[k].weekday.toLowerCase()));
  if (byWeekday) return { key: byWeekday, ...DAY_THEMES[byWeekday], displayName: value.trim() };
  return null;
};
